<script setup lang="ts"></script>

<template>
  <div class="base-button-group">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.base-button-group {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
}
</style>
